module.exports = __webpack_public_path__ + "media/images/gramatica_espanol_logo-a4913e026f5654a2ae7ccd128fe44273.jpg";